import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/AppShell";
import { CdpObjectiveDashboard } from "@/components/CdpObjectiveView";
import { Skeleton } from "@/components/ui/skeleton";
import { Target } from "lucide-react";

export default function MesObjectifs() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data: d } = await api.get("/performance/cdp/me");
      setData(d);
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const hitToday = data?.today?.hit;
  return (
    <>
      <PageHeader
        title="Mes Objectifs"
        subtitle={`Bonjour ${user?.name || ""} — objectif du jour : ${data?.target ?? 3} spots bookés. ${hitToday ? "Objectif atteint, bravo ! 🎉" : "Chaque spot compte, on y va ! 🎯"}`}
      />
      <div className="mx-auto max-w-[1000px] px-4 py-5 sm:px-6 lg:px-8" data-testid="mes-objectifs-page">
        {loading ? (
          <div className="space-y-4">
            <Skeleton className="h-44 w-full rounded-[var(--radius)]" />
            <Skeleton className="h-32 w-full rounded-[var(--radius)]" />
            <div className="grid gap-4 md:grid-cols-2">
              <Skeleton className="h-40 w-full rounded-[var(--radius)]" />
              <Skeleton className="h-40 w-full rounded-[var(--radius)]" />
            </div>
          </div>
        ) : (
          <CdpObjectiveDashboard data={data} />
        )}
      </div>
    </>
  );
}
